const externalMapUrl = card => {
  const lat = card?.publicInformation?.address?.location?.y;
  const lng = card?.publicInformation?.address?.location?.x;
  let url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  if (typeof navigator === 'undefined') return url;
  const { platform, userAgent: ua } = navigator;
  if (
    /iPad|iPhone|iPod/.test(ua) ||
    (platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  ) {
    url = `http://maps.apple.com/?daddr=${lat},${lng}`;
    // return 'iOS';
  } else if (/android/i.test(ua)) {
    url = `http://maps.google.com/?daddr=${lat},${lng}`;
    // return 'Android';
  }

  return url;
  // return 'Default';
};
export default externalMapUrl;
